/*

    Module: jv.common.typeahead.directive.js
    Directive: jvTypeahead

    A directive designed to mimic select2 but provide greater control over an initial view.

    Arguments:
    - config: object
    - on-select: function(item) - called with item selected by user
    - on-search: function(query) - called when user searches in input
    - on-scroll-end: function(query) - called when user scrolls results to bottom
    - model

    Config:

        initialView: {
            cols: [
                {
                    header: string,
                    list: array - items to display,
                    listLabel: function - format the array object to display, can return html
                },
                ...
            ]
        },
        searchView: {
            header: string,
            list: array - items to display,
            listLabel: function - format the array object to display, can return html
        },
        label: function - label to display when value is selected,
        property: (optional) string - which value to pick from array objects

    Example Usage:

        <div jv-typeahead="config" on-search="getInitialReqs(query)" on-scroll-end="scrollReqs(query)" model="filterModel" class="jv-req-filter">
            <header class="row margin-bottom-x-small">
                Custom header.
            </header>
        </div>

 */

angular.module('jv.common.typeahead.directive.js', [
    (function(){
        if (typeof require === 'function') {
            require('./jv.HideOnBlur')
        }
        return 'jv.Common.Directives.HideOnBlur';
    })(),
    (function(){
        if (typeof require === 'function') {
            require('../jv.Debounce')
        }
        return 'jv.Common.Debounce';
    })(),
    (function(){
        if (typeof require === 'function') {
            require('./jv.focus-on.directive')
        }
        return 'jv.common.focus-on.directive';
    })(),
    (function(){
        if (typeof require === 'function') {
            require('./jv.Common.keyboardEvents.directive')
        }
        return 'jv.Common.keyboardEvents.directive';
    })()
])
.directive('jvTypeahead', [
    '$document', '$timeout', 'debounce',
    function($document, $timeout, debounce) {
        return {
            scope: {
                config: '=jvTypeahead',
                onSelect: '&',
                onSearch: '&',
                onScrollEnd: '&',
                model: '='
            },
            transclude: true,
            link: function(scope, element, attrs, ctrl, transclude) {
                var state = scope.state = {};
                var dropdown = element.find('.jv-typeahead-dropdown');
                var container = element.find('.select2-container');
                var results = element.find('.jv-typeahead-search-results');
                var onSelect = scope.onSelect;
                dropdown.addClass('ng-hide');
                dropdown.appendTo($document[0].body);

                if (dropdown[0]) {
                    dropdown[0].addEventListener('scroll', debounce(function(event) {
                        var target = event.target;
                        var promise;
                        if (target === results[0]) {
                            if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 15) {
                                promise = scope.onScrollEnd({ query: state.query });
                                if (promise && promise.then) {
                                    state.loadingMore = true;
                                    promise.finally(function() {
                                        state.loadingMore = false;
                                    });
                                }
                            }
                        }
                    }, 100), true); // pass true to capture scroll event (it doesn't bubble)
                }

                transclude(function(clone) {
                    dropdown.prepend(clone.filter('header'));
                });

                container.on('focus', function() {
                    $timeout(function() {
                        state.focused = true;
                    });
                });

                container.on('blur', function() {
                    $timeout(function() {
                        state.focused = false;
                    });
                });

                function scrollIntoView() {
                    var item = angular.element('#req-item' + state.activeIndex);
                    var itemTop = Math.ceil(item[0].offsetTop);
                    var itemHeight = Math.ceil(item[0].offsetHeight);
                    if (itemTop + itemHeight > results[0].offsetHeight + results[0].scrollTop) {
                        results[0].scrollTop = itemTop + itemHeight - results[0].offsetHeight;
                    }
                    if (itemTop < results[0].scrollTop) {
                        results[0].scrollTop = itemTop;
                    }
                }

                scope.onSelect = function(item) {
                    scope.hide();
                    if (item) {
                        if (scope.config.property) {
                            scope.model = item[scope.config.property];
                        }
                        else {
                            scope.model = item;
                        }
                    }
                    else {
                        scope.model = null;
                    }
                    onSelect({ item: item });
                };

                scope.reset = function(event) {
                    event.stopPropagation();
                    scope.model = null;
                    scope.state.query = null;
                    scope.hide();
                };

                scope.dynamicClass = function() {
                    var classes = [];
                    if (state.focused) {
                        classes.push('select2-container-active');
                    }
                    if (state.show) {
                        classes.push('select2-dropdown-open', 'select2-container-active');
                    }
                    return classes.join(' ');
                };

                scope.show = function() {
                    var value;
                    var index;
                    var col;
                    dropdown.css('top', element.offset().top + element.height() - 1);
                    dropdown.css('left', element.offset().left);
                    state.show = true;
                    if (scope.model) {
                        scope.config.initialView.cols.some(function(column, i) {
                            return column.list.some(function(item, ii) {
                                value = (scope.config.property) ? item[scope.config.property] : item;
                                if (angular.equals(value, scope.model)) {
                                    index = ii;
                                    col = i;
                                    return true;
                                }
                            });
                        });
                    }
                    state.activeIndex = index;
                    state.activeCol = col;
                };

                scope.hide = function() {
                    state.show = false;
                    state.query = null;
                    if (parseFloat(jQuery.fn.jquery) > 1.7) {
                        container.trigger('focus');
                    } else {
                        container.focus();
                    }
                };

                scope.isActive = function(index, col) {
                    if (col != null) {
                        return (state.activeIndex === index && state.activeCol === col);
                    }
                    return (state.activeIndex === index);
                };

                scope.setActive = function(index, col) {
                    state.activeIndex = index || 0;
                    state.activeCol = col || 0;
                }

                scope.selectActive = function() {
                    if (state.query) {
                        scope.onSelect(scope.config.searchView.list[state.activeIndex]);
                    }
                    else {
                        scope.onSelect(scope.config.initialView.cols[state.activeCol].list[state.activeIndex]);
                    }
                };

                scope.handleDropdownArrowDownKey = function() {
                    if (state.activeIndex == null) {
                        state.activeIndex = 0;
                        state.activeCol = 0;
                        return;
                    }
                    if (state.query) {
                        state.activeIndex = Math.min(scope.config.searchView.list.length - 1, state.activeIndex + 1);
                        scrollIntoView();
                    }
                    else {
                        if (state.activeIndex > scope.config.initialView.cols[state.activeCol].list.length - 2) {
                            if (scope.config.initialView.cols[state.activeCol + 1]) {
                                state.activeIndex = 0;
                                state.activeCol += 1;
                            }
                        }
                        else {
                            state.activeIndex += 1;
                        }
                    }
                };

                scope.handleDropdownArrowUpKey = function() {
                    if (state.activeIndex == null) {
                        state.activeIndex = 0;
                        state.activeCol = 0;
                        return;
                    }
                    if (state.query) {
                        state.activeIndex = Math.max(0, state.activeIndex - 1);
                        scrollIntoView();
                    }
                    else {
                        if (state.activeIndex === 0) {
                            if (scope.config.initialView.cols[state.activeCol - 1]) {
                                state.activeIndex = scope.config.initialView.cols[state.activeCol - 1].list.length - 1;
                                state.activeCol -= 1;
                            }
                        }
                        else {
                            state.activeIndex -= 1;
                        }
                    }
                };

                scope.$watch('state.query', function() {
                    state.searching = true;
                    results.scrollTop(0);
                });
                scope.$watch('state.query', debounce(function(val) {
                    state.activeIndex = state.activeCol = 0;
                    if (val && val.length > 2) {
                        scope.onSearch({ query: val }).then(function() {
                            state.searching = false;
                        });
                    }
                }, 750));

                scope.$on('hideTypeahead', scope.hide);
            },
            templateUrl: jvUrls.jhire + '/htm/common/typeahead-template.html'
        };
    }
]);